<template>
  <div class="myautocustomer">
    <el-autocomplete :size="size" :clearable="true" :hide-loading="true"
                     popper-class="my-autocomplete" ref="droplist1"
                     v-model="myContent"
                     style="width:100%;"
                     prefix-icon="el-icon-search"
                     onfocus="this.select()"
                     :fetch-suggestions="querySearchAsync"
                     :placeholder="placeholder" :select-when-unmatched="true" @clear="clear"
                     @select="handleSelect" :debounce=5>
      <template slot-scope="{ item }">
        <div>{{item.deptname }} {{ item.linkmantel }} </div>
        <!--<span style="font-size: 12px;color: #b4b4b4;" v-if="splitByAddress">{{ item.deliveryaddress }}</span>-->
      </template>
    </el-autocomplete>
    <input type="text" ref="hide1" style="width:0px;height:0px;position:absolute;filter:alpha(opacity:0); opacity:0;  -moz-opacity:0;-khtml-opacity: 0"/>
  </div>
</template>

<script>
  import {getpinyinlistData} from '@/api/set/externaldept';

  export default {
    name: "AutoComplete",
    data() {
      return {
        myContent: this.content,
        pinyinData: [],
      }
    },
    props: {
      content: {//显示的文本
        default:""
      },
      splitByAddress:{//是否需要根据收货地址拆分多条记录
        default:false
      },
      unitgroup: {//1 表示客户，2表示经销商，3表示供应商
        default: 1
      },
      parentCustomerSerial:{//上级客户编码
        default:""
      },
      settingmenthod:{//200表示月结的客户
        default:""
      },
      placeholder:{//提示文本
         default:'搜索客户，enter键结束'
      },
      size:{//  大小，取值 ""/medium / small / mini
        default:  ""
      }
    },
    methods: {
      clearContent(){
        this.myContent="";
      },
      clear() {//清空
        this.$emit("clear");
      },
      //显示区域显示的列表数据
      querySearchAsync(queryString, cb) {
        cb(this.pinyinData);
      },
      //选中后执行，按enter也触发
      handleSelect(item) {
        if (!item.unitguid) {
          this.$refs.hide1.focus()
          this.bindGrid()
        } else {
          this.myContent = item.deptname
          //处理选中之后的地址session问题
          this.$emit("handleSelect", item.customerserial, item.deptname, item);
        }
      },
      bindGrid() {
        this.pinyinData = []
        if (this.myContent.length < 1) {
          this.$message({
            message: '至少一位',
            type: 'warning',
            duration: '1500',
          })
          return
        }
        getpinyinlistData({
          search: this.myContent.trim().toLocaleLowerCase(),
          unitgroup: this.unitgroup,
          parentcustomerserial: this.parentCustomerSerial,
          settingmenthod:this.settingmenthod,
          splitByAddress: this.splitByAddress ? "1" : "0"
        }).then(response => {
          this.pinyinData = response.data.obj
          for (let i = 0; i < this.pinyinData.length; i++) {
            this.pinyinData[i].value = this.pinyinData[i].fpinyin
          }
          if (this.pinyinData.length == 1) {
            this.handleSelect(this.pinyinData[0]);
          } else {
            this.$refs.droplist1.focus()
          }
        }).catch((error) => {
          console.log(error)
        });
      },
    },
    watch: {
      content(val) {
        this.myContent = val;
      }
    },

    mounted() {
      this.$nextTick(() => {
        this.$refs.droplist1.focus()
      })
    }

  }
</script>

<style>
  .my-autocomplete{
    min-width:460px !important;
  }
  .my-autocomplete .el-autocomplete-suggestion__wrap{
    max-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/AutoCustomer.vue